import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "../global/global";

@Injectable({
  providedIn: "root",
})
export class TerminosYCondicionesService {
  private baseUrl = GlobalVariable.BASE_API_URL; // Ajusta esto si necesitas una URL base diferente

  constructor(private http: HttpClient) {}

  aceptarTerminos(data: {
    tipo_usuario: string;
    id: number;
    tc_aceptado: number;
  }): Observable<any> {
    return this.http.post(this.baseUrl + "api/terminos/aceptar", data);
  }

  obtenerTerminos(tipo_usuario: string): Observable<any> {
    const url = `${GlobalVariable.BASE_API_URL}api/terminos/ultimo/${tipo_usuario}`;
    return this.http.get(url);
  }

  obtenerTerminosPorVersion(tipo_usuario: string, version: number): Observable<any> {
    const url = `${GlobalVariable.BASE_API_URL}api/terminos/${tipo_usuario}/${version}`;
    return this.http.get(url);
  }
}
